import React, { useState, useEffect, useContext } from "react";

//libs
import { Fade } from "react-reveal";
import { AnimateSharedLayout, AnimatePresence, motion } from "framer-motion";
import { Grid } from "@mui/material";

import {
  ProjectsPage,
  ProjectsScreen,
  ProjectsContainer,
  CustomButton,
} from "./projects.styles";

//utils
import projects from "../../utils/projects.data";

import { ThemeContext } from "../../theme.context";

//components
import ProjectOverview from "../../components/projectOverview/projectOverview.component";
import ProjectModal from "../../components/projectModal/projectModal.component";

const Projects = () => {
  const [selectedId, setSelectedId] = useState(null);
  const { darkMode } = useContext(ThemeContext);

  useEffect(() => {
    console.log(selectedId);
  }, [selectedId]);

  return (
    <ProjectsPage>
      <div class="custom-shape-divider-bottom-1646408644">
        <svg
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path
            d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
            class="shape-fill"
            fill={darkMode ? "#1C2028" : "#fff"}
          ></path>
        </svg>
      </div>
      <ProjectsScreen id="projects-section" dark={darkMode}>
        <Fade left>
          <h1 className="page-title">MY TOP PROJECTS</h1>
        </Fade>
        <Fade bottom delay={1000} className="projects-container">
          <ProjectsContainer container>
            {projects.map((project) => (
              <Grid item md={project.len} sm={6} xs={12} id={project.name}>
                <ProjectOverview
                  project={project}
                  selectProject={setSelectedId}
                  disabled={selectedId !== null}
                />
              </Grid>
            ))}
          </ProjectsContainer>
        </Fade>
        <div className="btn-container">
          <Fade delay={1500} bottom>
            <CustomButton
              dark={darkMode}
              onClick={() => {
                window.open("https://github.com/shivam256", "_blank");
              }}
              style={{marginTop:'20px'}}
            >
              VIEW ALL PROJECTS
            </CustomButton>
          </Fade>
        </div>
      </ProjectsScreen>
    </ProjectsPage>
  );
};

export default Projects;
